import { useState } from "react";
import {  useTranslation } from "react-i18next";
import { FaExclamationTriangle } from "react-icons/fa";
import useWindowDimensions from "utils/WindowSize";

import "./FallbackComponent.css";
import { CustomButtonType } from "components/CustomButton/CustomButtonType";
import CustomButton from "components/CustomButton/CustomButton";
import LogoHeader from "components/LogoHeader/LogoHeader";
import CustomTranslation from "components/CustomTranslation/CustomTranslation";

const FallbackComponent: React.FC<{ error: Error; resetErrorBoundary: (...args: Array<unknown>) => void }> = ({ error, resetErrorBoundary }) => {
	const { width } = useWindowDimensions();
	const [logoExpanded] = useState<boolean>(width > 800);

	const { t } = useTranslation("HSB.FallbackComponent",{useSuspense:false});

	return (
		<>
			<div className={`navbar_wrapper`} id={"navbar"} style={{ position: "fixed" }}>
				<div className={`logo_wrapper`}>
					<LogoHeader logoExpanded={logoExpanded} />
				</div>
				<div className={"nav_elements"}></div>
			</div>
			<div className="App">
				<div className="app-container" id="app-container">
					<div className="app-content-box"></div>
					<div role="alert" className="fallback-alert-content">
						<FaExclamationTriangle className="alert-ico"></FaExclamationTriangle>
						<p>
							<CustomTranslation
								t={t}
								i18Key="fallBack.BrowserErrorMessage"								
								customComponents={{
									br: <br />,
								}}								
							/>
						</p>
						<pre style={{ display: "none" }} id="error-message">
							{error.message}
						</pre>
						<CustomButton text={t("fallBack.Reload")} OnClick={resetErrorBoundary} buttonType={CustomButtonType.positive} />
					</div>
				</div>
			</div>
		</>
	);
};

export default FallbackComponent;
